const ResponseText = ({ answer }) => (
  <div className="Content cached-response-text">
    {typeof answer === "string"
      ? answer.replace(/\\r\\n|\\n|\\r/g, "\n")
          .split(/(\*\*[^*]+\*\*|\*[^*\n]+\*)/g)
          .map((part, index) => {
            if (part.startsWith("**") && part.endsWith("**")) {
              return <strong key={index}>{part.slice(2, -2)}</strong>;
            }
            if (part.startsWith("*") && part.endsWith("*") && part.length > 1) {
              return <em key={index}>{part.slice(1, -1)}</em>;
            }
            return part;
          })
      : answer}
  </div>
);

export default ResponseText;
